import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fileInput", "dropzone", "previewArea", "submitBtn", "form"]

  openFileDialog() {
    this.fileInputTarget.click()
  }

  handleFiles() {
    const files = Array.from(this.fileInputTarget.files)
    if (files.length === 0) return

    if (files.length > 5) {
      alert("画像は最大5枚までです")
      this.fileInputTarget.value = ""
      return
    }

    const invalidFiles = files.filter(f => {
      const validTypes = ["image/jpeg", "image/png", "image/webp"]
      return !validTypes.includes(f.type) || f.size > 10 * 1024 * 1024
    })

    if (invalidFiles.length > 0) {
      alert("JPEG、PNG、WebP形式で10MB以下の画像を選択してください")
      this.fileInputTarget.value = ""
      return
    }

    this.showPreviews(files)
    this.submitBtnTarget.classList.remove("hidden")
    this.submitBtnTarget.disabled = false
    this.submitBtnTarget.textContent = `${files.length}枚の読み取りを開始`
  }

  showPreviews(files) {
    this.previewAreaTarget.innerHTML = ""
    this.previewAreaTarget.classList.remove("hidden")

    files.forEach(file => {
      const reader = new FileReader()
      reader.onload = (e) => {
        const div = document.createElement("div")
        div.className = "relative aspect-square rounded-lg overflow-hidden border border-gray-200"
        div.innerHTML = `<img src="${e.target.result}" class="w-full h-full object-cover">`
        this.previewAreaTarget.appendChild(div)
      }
      reader.readAsDataURL(file)
    })
  }

  submit(event) {
    this.submitBtnTarget.disabled = true
    this.submitBtnTarget.textContent = "アップロード中..."
  }

  dragOver(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.add("border-brand-500", "bg-brand-50")
  }

  dragEnter(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.add("border-brand-500", "bg-brand-50")
  }

  dragLeave(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("border-brand-500", "bg-brand-50")
  }

  drop(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("border-brand-500", "bg-brand-50")

    const files = event.dataTransfer.files
    if (files.length > 0) {
      this.fileInputTarget.files = files
      this.handleFiles()
    }
  }
}
